// extracted by mini-css-extract-plugin
export default {"breedingLineage":"FamilyTree_breedingLineage__vQmOo","tableContainer":"FamilyTree_tableContainer__RS13X","darkBg":"FamilyTree_darkBg__4iSmm"};